import { render, staticRenderFns } from "./ModalFooter.vue?vue&type=template&id=21e71121&scoped=true&"
import script from "./ModalFooter.vue?vue&type=script&lang=ts&"
export * from "./ModalFooter.vue?vue&type=script&lang=ts&"
import style0 from "./ModalFooter.vue?vue&type=style&index=0&id=21e71121&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21e71121",
  null
  
)

export default component.exports